<template>
  <VueFinalModal
    :content-class="getContentClass"
    display-directive="show"
  >
    <div class="modal-content rounded-20">
      <div class="modal-header">
        <slot name="header" />
        <button
          v-if="!hideClose"
          class="btn-close"
          type="button"
          aria-label="Закрыть"
          title="Закрыть"
          @click="$emit('confirm')"
        />
      </div>
      <div class="modal-body">
        <slot name="body" />
      </div>
      <div
        v-if="!!$slots['footer']"
        class="modal-footer"
      >
        <slot name="footer" />
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup lang="ts">

import { VueFinalModal } from "vue-final-modal";
import { ModalSize } from "~/composables/enums/ModalSize";

//-----PROPS-----\\
const props = defineProps({
  size: { type: Number, default: () => ModalSize.Medium },
  hideClose: { type: Boolean, default: () => false },
});
defineEmits(['confirm']);

//-----VARIABLES-----\\

//-----STATE-----\\

//-----COMPUTED-----\\
const getContentClass = computed<string>(() => {
  let classList: string[] = [];

  if (props.size === ModalSize.Medium) {
    classList.push('modal-md');
  } else if (props.size === ModalSize.Small) {
    classList.push('modal-sm');
  } else if (props.size === ModalSize.Large) {
    classList.push('modal-lg');
  } else if (props.size === ModalSize.Xlarge) {
    classList.push('modal-xl');
  }

  return 'modal-dialog modal-dialog-centered modal-fullscreen-md-down ' + classList.join(' ');
});

//-----ASYNC-----\\

//-----METHODS-----\\

</script>